export enum WithdrawalPlatformType {
    PAYPAL = "Paypal",
    VENMO = "Venmo",
}